import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from "rxjs";
import {StartECasePreferencesRepository} from "./start-ecase-preferences-repository";
import {MenuItem} from "./models/menu-item";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class StartECasePreferencesService implements  StartECasePreferencesRepository {
  private defaultPublicServiceURL = '/public-api/app-start-ecase-public-service/';
  private publicServiceURL = this.resolvePublicServiceURL();

  constructor(private http: HttpClient) { }

  findAllServiceSets(): Observable<MenuItem[]> {
    return this.http.get<MenuItem[]>(this.publicServiceURL + 'startecase/preferences/servicesets');
  }

  private resolvePublicServiceURL(): string {
    return document['preferences'].publicServiceURL === undefined ? this.defaultPublicServiceURL : document['preferences'].publicServiceURL;
  }

}



// WEBPACK FOOTER //
// ./src/app/start-ecase-preferences-service.ts